// @todo intersection observer?
// imports
import { checkIfElementInViewport } from '../utils/elInViewport';

const contactWidget = document.querySelector('.contact-widget');
const contactWidgetIcon = document.querySelector('.contact-widget__icon');
const contactWidgetWrapper = document.querySelector(
  '.contact-widget__block-wrapper',
);
const contactWidgetOpenClass = 'contact-widget--open';
const widgetFixedClass = 'contact-widget__block-wrapper--fixed';
let contactWidgetOpen = false;

const openWidget = () => {
  contactWidget.classList.add(contactWidgetOpenClass);
  contactWidgetOpen = true;
};

const closeWidget = () => {
  contactWidget.classList.remove(contactWidgetOpenClass);
  contactWidgetOpen = false;
};

const toggleContactWidget = () => {
  contactWidgetIcon.addEventListener('click', () => {
    if (contactWidgetOpen) {
      closeWidget();
    } else {
      openWidget();
    }
  });
};

const buildStickyState = () => {
  if (checkIfElementInViewport('.contact-widget-stop')) {
    contactWidgetWrapper.classList.remove(widgetFixedClass);
  } else {
    contactWidgetWrapper.classList.add(widgetFixedClass);
  }
};

(() => {
  if (contactWidget) {
    toggleContactWidget();
    buildStickyState();
  }
})();

// window events
if (contactWidget) {
  // on click outside
  window.addEventListener('click', ({ target }) => {
    const isClickInside = contactWidget.contains(target);
    const isClickOnIcon = contactWidgetIcon.contains(target);

    if (contactWidgetOpen && !isClickOnIcon && !isClickInside) {
      closeWidget();
    }
  });

  // on scroll
  window.addEventListener('scroll', () => {
    buildStickyState();
  });

  // on resize
  window.addEventListener('resize', () => {
    closeWidget();
  });
}
